interface TrainingTermRange {
  start: number;
  end: number | null;
  term: string;
}

const TRAINING_TERM_RANGES: TrainingTermRange[] = [
  { start: 5251, end: 5391, term: '1期' },
  { start: 5392, end: 5602, term: '2期' },
  { start: 5603, end: 5834, term: '3期' },
  { start: 5835, end: 6077, term: '4期' },
  { start: 6078, end: 6262, term: '5期' },
  { start: 6263, end: 6497, term: '6期' },
  { start: 6498, end: 6719, term: '7期' },
  { start: 6720, end: 6907, term: '8期' },
  { start: 6908, end: 7167, term: '9期' },
  { start: 7168, end: 7446, term: '10期' },
  { start: 7447, end: 7715, term: '11期' },
  { start: 7716, end: 7990, term: '12期' },
  { start: 7991, end: 8310, term: '13期' },
  { start: 8311, end: 8633, term: '14期' },
  { start: 8634, end: 8973, term: '15期' },
  { start: 8974, end: 9354, term: '16期' },
  { start: 9355, end: 9788, term: '17期' },
  { start: 9789, end: 10291, term: '18期' },
  { start: 10292, end: 10790, term: '19期' },
  { start: 10791, end: 11266, term: '20期' },
  { start: 11267, end: 11781, term: '21期' },
  { start: 11782, end: 12319, term: '22期' },
  { start: 12320, end: 12843, term: '23期' },
  { start: 12844, end: 13506, term: '24期' },
  { start: 13507, end: 14012, term: '25期' },
  { start: 14013, end: 14508, term: '26期' },
  { start: 14509, end: 15049, term: '27期' },
  { start: 15050, end: 15534, term: '28期' },
  { start: 15535, end: 16027, term: '29期' },
  { start: 16028, end: 16451, term: '30期' },
  { start: 16452, end: 16898, term: '31期' },
  { start: 16899, end: 17317, term: '32期' },
  { start: 17318, end: 17810, term: '33期' },
  { start: 17811, end: 18290, term: '34期' },
  { start: 18291, end: 18742, term: '35期' },
  { start: 18743, end: 19160, term: '36期' },
  { start: 19161, end: 19587, term: '37期' },
  { start: 19588, end: 20036, term: '38期' },
  { start: 20037, end: 20484, term: '39期' },
  { start: 20485, end: 20961, term: '40期' },
  { start: 20962, end: 21447, term: '41期' },
  { start: 21448, end: 21948, term: '42期' },
  { start: 21949, end: 22415, term: '43期' },
  { start: 22416, end: 22911, term: '44期' },
  { start: 22912, end: 23370, term: '45期' },
  { start: 23371, end: 23876, term: '46期' },
  { start: 23877, end: 24452, term: '47期' },
  { start: 24453, end: 25106, term: '48期' },
  { start: 25107, end: 25760, term: '49期' },
  { start: 25761, end: 26426, term: '50期' },
  { start: 26427, end: 27090, term: '51期' },
  { start: 27091, end: 27747, term: '52期' },
  { start: 27748, end: 28496, term: '53期' },
  { start: 28497, end: 29407, term: '54期' },
  { start: 29408, end: 30347, term: '55期' },
  { start: 30348, end: 31380, term: '56期' },
  { start: 31381, end: 32580, term: '57期' },
  { start: 32581, end: 33723, term: '58期' },
  { start: 33724, end: 35164, term: '59期' },
  { start: 35165, end: 36444, term: '現行60期' },
  { start: 36445, end: 37428, term: '新60期' },
  { start: 37429, end: 38014, term: '現行61期' },
  { start: 38015, end: 39703, term: '新61期' },
  { start: 39704, end: 40051, term: '現行62期' },
  { start: 40052, end: 41984, term: '新62期' },
  { start: 41985, end: 42205, term: '現行63期' },
  { start: 42206, end: 44084, term: '新63期' },
  { start: 44085, end: 44263, term: '現行64期' },
  { start: 44264, end: 46236, term: '新64期' },
  { start: 46237, end: 48313, term: '65期' },
  { start: 48314, end: 50338, term: '66期' },
  { start: 50339, end: 52211, term: '67期' },
  { start: 52212, end: 53897, term: '68期' },
  { start: 53898, end: 55617, term: '69期' },
  { start: 55618, end: 57150, term: '70期' },
  { start: 57151, end: 58640, term: '71期' },
  { start: 58641, end: 60109, term: '72期' },
  { start: 60110, end: 61634, term: '73期' },
  { start: 61635, end: 62969, term: '74期' },
  { start: 62970, end: 64287, term: '75期' },
  { start: 64288, end: 65651, term: '76期' },
  { start: 65652, end: 67418, term: '77期' },
  { start: 67419, end: null, term: '78期' },
];

export interface RegistrationNumberNormalization {
  value: string | null;
  error: string | null;
}

export const REGISTRATION_NUMBER_ERROR = '登録番号は数字のみで入力してください';

export function normalizeRegistrationNumber(
  input: string | null | undefined,
): RegistrationNumberNormalization {
  const trimmed = input?.trim() ?? '';
  if (trimmed.length === 0) return { value: null, error: null };

  let value = '';
  for (const char of trimmed) {
    const code = char.charCodeAt(0);
    if (code >= 0x30 && code <= 0x39) {
      value += char;
    } else if (code >= 0xff10 && code <= 0xff19) {
      value += String.fromCharCode(0x30 + code - 0xff10);
    } else {
      return { value: null, error: REGISTRATION_NUMBER_ERROR };
    }
  }

  return { value, error: null };
}

export function resolveTrainingTermFromRegistrationNumber(
  input: string | null | undefined,
): string | null {
  const normalized = normalizeRegistrationNumber(input);
  if (normalized.error || !normalized.value) return null;
  return resolveTrainingTermFromNormalizedRegistrationNumber(normalized.value);
}

export function resolveTrainingTermFromNormalizedRegistrationNumber(
  registrationNumber: string,
): string | null {
  const value = registrationNumberValue(registrationNumber);
  if (value === null) return null;
  return (
    TRAINING_TERM_RANGES.find(
      (range) =>
        range.start <= value && (range.end === null || value <= range.end),
    )?.term ?? null
  );
}

function registrationNumberValue(registrationNumber: string): number | null {
  const significant = registrationNumber.replace(/^0+/, '');
  if (significant.length === 0) return 0;
  if (significant.length > 5) return 100000;
  const value = Number.parseInt(significant, 10);
  return Number.isFinite(value) ? value : null;
}
